import Image from 'next/legacy/image';
import { H2 } from '@components/atoms/typography';
import useWindowSize from '@hooks/useWindowSize';

const Maintenance = ({
  message = 'Under Maintenace',
  subMessage
}: {
  message: string;
  subMessage?: React.ReactNode;
}) => {
  const { width } = useWindowSize();
  const isMobile = width < 500;

  return (
    <div
      className="flex flex-col items-center justify-center h-full p-5 pb-10 space-y-5"
      data-cy="maintenance-component"
    >
      <H2 className="text-center">{message}</H2>
      {subMessage && subMessage}
      <div className="py-3">
        {isMobile ? (
          <Image
            className="w-full "
            src={'/images/skeleton/mobile-my-team.png'}
            height={1000}
            width={350}
            priority
            alt="My Team placeholder image"
          />
        ) : (
          <Image
            className="w-full "
            src={'/images/skeleton/my-team.png'}
            height={600}
            width={1000}
            priority
            alt="My Team placeholder image"
          />
        )}
      </div>
    </div>
  );
};

export default Maintenance;
